import type { AnalyticsAdapter, AnalyticsEvent } from '../types';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export class GA4Adapter implements AnalyticsAdapter {
  name = 'ga4';
  requiredConsent = 'analytics' as const;
  private gaId: string;
  private loaded = false;

  constructor(gaId: string) {
    this.gaId = gaId;
  }

  load() {
    if (this.loaded || typeof window === 'undefined') return;
    this.loaded = true;

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', this.gaId, { send_page_view: false });

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.gaId}`;
    script.async = true;
    document.head.appendChild(script);
  }

  track(event: AnalyticsEvent) {
    if (typeof window === 'undefined' || !window.gtag) return;
    const { context, ...rest } = event;
    window.gtag('event', event.name, {
      event_category: event.category,
      ...event.properties,
      client_type: context.client,
      platform: context.platform,
      screen_bucket: context.screenBucket,
      ...rest.properties,
    });
  }

  page(path: string) {
    if (typeof window === 'undefined' || !window.gtag) return;
    window.gtag('event', 'page_view', { page_path: path });
  }

  identify(userId: string) {
    if (typeof window === 'undefined' || !window.gtag) return;
    window.gtag('config', this.gaId, { user_id: userId });
  }

  reset() {
    if (typeof window === 'undefined' || !window.gtag) return;
    window.gtag('config', this.gaId, { user_id: undefined });
  }
}
